import React from 'react'


function AnnotationColorBox(props) {
  return (
    <div style={{
        backgroundColor:props.color,
        height:"30px",
        width:"30px",
    }}></div>
  )
}

export default AnnotationColorBox